import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "circle-crossmark_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10Zm-5-3.5L15.5 7 12 10.5 8.5 7 7 8.5l3.5 3.5L7 15.5 8.5 17l3.5-3.5 3.5 3.5 1.5-1.5-3.5-3.5L17 8.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }